import { useSyncExternalStore } from 'react';
import { AlertCircle, X } from 'lucide-react';
import { systemNotifications } from '@/lib/system-notifications';
import './system-notifications.css';

export function SystemNotifications() {
  const items = useSyncExternalStore(systemNotifications.subscribe, systemNotifications.getSnapshot, systemNotifications.getSnapshot);
  const current = items[0];
  const waiting = items.slice(1).reduce((sum, item) => sum + item.count, 0);
  return <aside className="system-notification-region" aria-label="Notifications" aria-live="polite" aria-atomic="true">
    {current && <section key={current.id} className="system-notification-card" data-testid="system-notification">
      <AlertCircle size={18} className="system-notification-icon" aria-hidden="true" />
      <div className="system-notification-content">
        <p className="system-notification-title">{current.title}</p>
        <p>{current.description}</p>
        {current.count > 1 && <p className="system-notification-count">{current.count} occurrences</p>}
        {waiting > 0 && <div className="system-notification-actions">
          <button onClick={() => systemNotifications.dismiss(current.id)}>Next ({waiting} more)</button>
          <button onClick={() => systemNotifications.clear()}>Dismiss all</button>
        </div>}
      </div>
      <button className="system-notification-close" aria-label="Dismiss notification" onClick={() => systemNotifications.dismiss(current.id)}><X size={16} /></button>
    </section>}
  </aside>;
}
